module.exports = __webpack_public_path__ + "img/jishipandian.2bc7410f.png";